import React from 'react';
import Amplify, { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import DetailFaq from './detailFaq';
import Tutorial from '../common/tutorial';
import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
} from '../../Actions/actions';
import * as SecretKeys from '../../ENV.json';
import BannerHead from '../BannerHead';

Amplify.configure(SecretKeys.awsUserpool);

class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
    };
  }
  /**
   * Get the information of the user
   */

  componentWillMount() {
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
  }

  /**
   * Get all settlement list with filter
   */
  componentDidMount() {
    this.props.getAllSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: 'unknown',
    });
  }

  /**
   * Logout the user
   */
  logout() {
    Auth.signOut()
      .then(() => {
        localStorage.clear();
        this.context.router.history.push('/');
      })
      .catch(error => error);
  }

  scrollStep=() => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  render() {
    return (
      <div className="container">
        <div className="main-content">
          <div className="section-content support">
            <div className="row">
              <div className="dashboard my-profile">
                <div className="dashboard-tabs heading-btn">
                  <div className="left-heading">
                    <BannerHead title="FAQ" />
                  </div>
                  <div className="left-heading">
                    <Tutorial />
                  </div>
                </div>
              </div>
            </div>
            <div className="main-content">
              <div style={{ marginTop: '5px' }} />
              <DetailFaq />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Faq.contextTypes = {
  router: PropTypes.object.isRequired,
};

/**
 * Get the data from reducer
 * @param {} state
 */
const mapStateToProps = state => ({ data: state.data });

/**
 * set the data in reducer
 * @param {*} dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Faq),
);
